module.exports = __webpack_public_path__ + "media/images/logo-c79b5e99b3c1074070cc7d875180bef7.svg";